import { css } from "styled-components";

export const cssResets = {
  a: css`
    color: unset;
    cursor: unset;
    outline: unset;
    outline-offset: unset;
    text-decoration: unset;
  `,
  button: css`
    cursor: pointer;
    display: block;

    appearance: unset;
    background-color: unset;
    border: unset;
    color: unset;
    letter-spacing: unset;
    line-height: unset;
    margin: unset;
    padding-block: unset;
    padding-inline: unset;
    text-align: unset;
    text-indent: unset;
    text-rendering: unset;
    text-shadow: unset;
    text-transform: unset;
    word-spacing: unset;
  `,
  dialog: css`
    background-color: unset;
    border-color: unset;
    border-image: unset;
    border-style: unset;
    border-width: unset;
    color: unset;
    display: unset;
    height: unset;
    inset-inline-end: unset;
    inset-inline-start: unset;
    margin: unset;
    padding: unset;
    position: unset;
    width: unset;
  `,
  h1: css`
    font-size: unset;
    font-weight: unset;
    margin-block: unset;
  `,
  h2: css`
    font-size: unset;
    font-weight: unset;
    margin-block: unset;
  `,
  input: css`
    display: flex;
    cursor: text;

    -webkit-rtl-ordering: unset;
    appearance: unset;
    background-color: unset;
    background-image: unset;
    border-color: unset;
    border-image: unset;
    border-style: unset;
    border-width: unset;
    color: unset;
    letter-spacing: unset;
    line-height: unset;
    margin: unset;
    outline-offset: unset;
    outline: unset;
    overflow: unset;
    padding-block: unset;
    padding-inline: unset;
    padding: unset;
    text-align: unset;
    text-indent: unset;
    text-rendering: unset;
    text-shadow: unset;
    text-transform: unset;
    word-spacing: unset;
  `,
  p: css`
    margin-block: unset;
  `,
};
